<template>
  <div>
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Dados de nascimento
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="row pl-3">
      <div class="col-12 col-md-4 col-sm-5">
        <label class="text-muted mb-1"> Nº Declaração Nascido Vivo</label>
        <p><b>{{ arquivoEstruturado.registro.dados_nascimento.numero_dnv || 'Não informado' }}</b></p>
      </div>
    </div>

    <BoxLocalOcorrencia :dados="localOcorrencia" />

    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Registrado
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Nome</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.nome || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Data de nascimento</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.data_nascimento.replaceAll('-', '/') || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Hora de nascimento</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.hora_nascimento || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Sexo</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.sexo === 'M' ? 'Masculino' : 'Feminino' || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>

    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Naturalidade
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Município</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.naturalidade.municipio || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">UF</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.naturalidade.uf || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">País</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.naturalidade.pais || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>

    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Gêmeos
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-2">
          <label class="text-muted mb-1">Possui gêmeos?</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.gemelar ? 'Sim' : 'Não' }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Ordem de nascimento</label>
          <p><b>{{ arquivoEstruturado.registro.registrado.ordem_nascimento || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import BoxLocalOcorrencia from '@/components/SofiaRei/Nascimento/BoxLocalOcorrencia'

  export default {
    name: 'DadosNascimento',
    components: {
      BoxLocalOcorrencia
    },
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        localOcorrencia: null
      }
    },
    created () {
      this.inicio ()
    },
    methods: {
      inicio () {
        const localNascimento = this.arquivoEstruturado.registro.dados_nascimento.local_nascimento

        this.localOcorrencia = {
          tipo: localNascimento.tipo_local_nascimento,
          descricao: localNascimento.nome_local_nascimento,
          endereco: {
            ...localNascimento.endereco
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>